module.exports = __webpack_public_path__ + "img/add-disabled.f16e2631.svg";